import styled, { css } from "styled-components";

import { setLightness } from "polished";
import { staffLines } from "../../../../common/styles";

export const Holder = styled.div`
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    padding-bottom: 20px;
    ${p =>
        p.theme.md.only(css`
            grid-template-columns: 1fr 1fr 1fr;
        `)}

    ${p =>
        p.theme.lg(css`
            grid-template-columns: 1fr 1fr 1fr 1fr;
        `)}
    ${p =>
        p.theme.sm.max(css`
            grid-template-columns: 1fr 1fr;
        `)}

    ${p =>
        p.theme.xs(css`
            grid-template-columns: 1fr;
        `)}
`;

export const Hero = styled.div`
    background-color: ${p => setLightness(0.27, p.theme.c.dark)};
    ${staffLines};
    margin: -20px -20px 0;
    padding: 70px 40px 42px;
    color: ${p => p.theme.c.light};
    border-bottom: solid 16px ${p => p.theme.c.info};
    display: flex;
    ${p =>
        p.theme.xs(css`
            flex-direction: column;
            text-align: center;
            padding: 52px 20px;
        `)}

    h2 {
        color: ${p => p.theme.c.info};
        margin-top: 16px;
    }
`;

const $userDimension = 200;
export const UserImage = styled.div`
    border-radius: ${$userDimension / 2}px;
    overflow: hidden;
    background-color: ${p => p.theme.c.boost};
    width: ${$userDimension}px;
    height: ${$userDimension}px;
    margin-right: 14px;
    box-sizing: border-box;
    border: 6px solid ${p => p.theme.c.active};
    ${p =>
        p.theme.xs(css`
            margin-left: auto;
            margin-right: auto;
        `)}
    ${p =>
        p.theme.sm.min(css`
            margin-right: 32px;
        `)}
    img {
        width: ${$userDimension - 12}px;
        height: ${$userDimension - 12}px;
    }

    .i-user {
        font-size: ${$userDimension}px;
        margin-top: -6px;
        margin-left: -6px;
        display: block;
        color: ${p => p.theme.c.dark};
        transform: scale(1.35);
    }
`;

export const Decoration = styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
    ${p =>
        p.theme.sm.min(css`
            margin-top: 0;
            flex-direction: column;
            margin-right: 32px;
        `)}
    justify-content: center;
`;

export const Bulb = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${p => p.theme.c.info};
    border: solid 5px ${p => p.theme.c.active};
    border-radius: 16px;
    box-sizing: border-box;
`;

export const Rod = styled.div`
    width: 140px;
    height: 5px;
    background-color: ${p => p.theme.c.active};
    margin: -1px;
    ${p =>
        p.theme.sm.min(css`
            width: 5px;
            height: 100px;
        `)}
`;
